import { render } from "./welcomeComponent.vue?vue&type=template&id=1abd0f34"
import script from "./welcomeComponent.vue?vue&type=script&lang=js"
export * from "./welcomeComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__